import React, { useState } from 'react';

import Badge from '@material-ui/core/Badge';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { makeStyles } from '@material-ui/core/styles';

import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from '@material-ui/icons/Search';
import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';

import Dialog from '../Dialog/Dialog';
import { ButtonPrimary, ButtonDefault } from '../Button/Button';

const useStyles = makeStyles(theme => ({
    bar: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        marginBottom: theme.spacing(1),
    },
    resumo: {
        marginLeft: theme.spacing(1.5),
        color: theme.palette.text.secondary,
        fontWeight: 500,
    },
    extra: {
        display: 'flex',
        marginLeft: 'auto',
    },
}));

export const FiltrosDialog = ({ children, resumo, activeCount = 0, onApply, onClear, extra }) => {
    const classes = useStyles();
    const [ open, setOpen ] = useState(false);

    const aplicar = () => {
        if (onApply) onApply();
        setOpen(false);
    };

    const limpar = () => {
        if (onClear) onClear();
    };

    return (
        <>
            <div className={classes.bar}>
                <ButtonPrimary
                    name="Filtros"
                    startIcon={
                        <Badge color="secondary" overlap="circle" badgeContent={activeCount} invisible={!activeCount}>
                            <FilterListIcon />
                        </Badge>
                    }
                    onClick={() => setOpen(true)}
                />

                { resumo &&
                    <Typography variant="body2" className={classes.resumo}>
                        {resumo}
                    </Typography>
                }

                { extra &&
                    <div className={classes.extra}>
                        {extra}
                    </div>
                }
            </div>

            <Dialog
                keepMounted
                fullWidth
                maxWidth="sm"
                openDialog={open}
                title="Filtros"
                closeDialog={() => setOpen(false)}
                actions={
                    <>
                        <ButtonDefault
                            name="Limpar"
                            startIcon={<ClearOutlinedIcon />}
                            onClick={limpar}
                            style={{ margin: 4 }}
                        />
                        <ButtonPrimary
                            name="Aplicar"
                            startIcon={<SearchIcon />}
                            onClick={aplicar}
                            style={{ margin: 4 }}
                        />
                    </>
                }
            >
                <Grid container spacing={2}>
                    {children}
                </Grid>
            </Dialog>
        </>
    );
};

export default FiltrosDialog;
